export default __webpack_public_path__ + "static/media/466.845dc957.jpg";